import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, AcaoFonteRecurso } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class AcaoFonteRecursoService extends BaseResourceService<AcaoFonteRecurso> {

  constructor(
    protected injector: Injector
  ) {
    super(`acoes-fonte-recurso`, injector);
  }

}
